"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _stores = require("@seedlang/stores");
var _root_state = _interopRequireDefault(require("./root_state"));
var _layouts = require("@seedlang/layouts");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// remember: don't include AppUI in a UI file

var targetLanguageFilters = ['vocabLevelId', 'vocabWordTypeId', 'vocabLearned', 'vocabReviewing', 'vocabHasSentence', 'vocabHasHighlightedVocabTriad', 'vocabSeen', 'vocabLanguagesWithWithout'];
var VocabUI = (_class = /*#__PURE__*/function (_RootState) {
  function VocabUI(parent) {
    var _this;
    _classCallCheck(this, VocabUI);
    _this = _callSuper(this, VocabUI);
    _initializerDefineProperty(_this, "filterCache", _descriptor, _this);
    _initializerDefineProperty(_this, "selectedWords", _descriptor2, _this);
    _initializerDefineProperty(_this, "caretPosition", _descriptor3, _this);
    _initializerDefineProperty(_this, "allToggleSelected", _descriptor4, _this);
    _initializerDefineProperty(_this, "userRequestIsPending", _descriptor5, _this);
    _initializerDefineProperty(_this, "targetLanguageRequestIsPending", _descriptor6, _this);
    _initializerDefineProperty(_this, "queuedUserData", _descriptor7, _this);
    _initializerDefineProperty(_this, "queuedTargetLanguageData", _descriptor8, _this);
    _initializerDefineProperty(_this, "vocabTab", _descriptor9, _this);
    _initializerDefineProperty(_this, "tabsPreviouslyTrainers", _descriptor10, _this);
    _initializerDefineProperty(_this, "deckId", _descriptor11, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor12, _this);
    _initializerDefineProperty(_this, "cardTypeId", _descriptor13, _this);
    _initializerDefineProperty(_this, "filteredItemsCount", _descriptor14, _this);
    _initializerDefineProperty(_this, "showFilterOptions", _descriptor15, _this);
    _initializerDefineProperty(_this, "overridePage", _descriptor16, _this);
    _initializerDefineProperty(_this, "pageFromParams", _descriptor17, _this);
    _initializerDefineProperty(_this, "learnedByLevel", _descriptor18, _this);
    _initializerDefineProperty(_this, "updatedDeviceLanguageId", _descriptor19, _this);
    _initializerDefineProperty(_this, "targetLanguageId", _descriptor20, _this);
    _initializerDefineProperty(_this, "defaultReviewDeckId", _descriptor21, _this);
    _initializerDefineProperty(_this, "newReviewDeckName", _descriptor22, _this);
    _initializerDefineProperty(_this, "createReviewsIsSlow", _descriptor23, _this);
    _initializerDefineProperty(_this, "createReviewsFinished", _descriptor24, _this);
    _initializerDefineProperty(_this, "wordVideoClips", _descriptor25, _this);
    _this.parent = parent;
    _this.layout = new _layouts.AppLayout(_this);
    _this.authUserStore = _stores.AuthUserStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    _this.deckStore = _stores.DeckStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.cardStore = _stores.CardStore;
    _this.wordStore = _stores.WordStore;
    _this.worksheetWordStore = _stores.WorksheetWordStore;
    _this.dashboardStore = _stores.DashboardStore;
    return _this;
  }
  _inherits(VocabUI, _RootState);
  return _createClass(VocabUI, [{
    key: "store",
    get: function get() {
      if (this.worksheetId) {
        return this.worksheetWordStore;
      } else {
        return this.wordStore;
      }
    }
  }, {
    key: "words",
    get: function get() {
      if (this.worksheetId && this.worksheetWordStore.hasIndexData) {
        return this.worksheetWordStore.indexData.map(function (item) {
          return item.word;
        });
      } else {
        return this.wordStore.indexData;
      }
    }
  }, {
    key: "onSetDeckId",
    value: function onSetDeckId(deckId) {
      this.deckId = deckId;
    }
  }, {
    key: "clearFilterCache",
    value: function clearFilterCache() {
      this.filterCache = {};
    }
  }, {
    key: "noFiltersSelectedMessage",
    get: function get() {
      var messages = {
        'frequency_ranking': 'No Filter Selected. Sorted By Most Frequent.',
        '-frequency_ranking': 'No Filter Selected. Sorted By Least Frequent.',
        'target_text': 'No Filter Selected. Sorted Alphabetically.',
        '-target_text': 'No Filter Selected. Sorted Reverse Alphabetically.'
      };
      return this.layout.isNative ? 'No Filter Selected.' : messages[this.sortWithDirection || 'frequency_ranking'];
    }
  }, {
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this2 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this2.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "sortWithDirection",
    get: function get() {
      var sort = this.sort;
      if (this.sortDirection === 'desc') {
        sort = "-".concat(sort);
      }
      return sort;
    }
  }, {
    key: "showSpinner",
    get: function get() {
      return this.store.requestCounter > 0;
    }
  }, {
    key: "languagesStringFormatted",
    get: function get() {
      if ((0, _utils.isPresent)(this.languagesEnable) && (0, _utils.isPresent)(this.user.languageId)) {
        return "".concat(this.languagesWithWithout, " ").concat(this.user.languageId.startsWith('EN') ? 'English' : _constants.Languages[this.user.languageId]);
      }
    }
  }, {
    key: "hasActiveFilter",
    get: function get() {
      return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
        return !item.hide && (0, _utils.isPresent)(item.value);
      }));
    }
  }, {
    key: "filters",
    get: function get() {
      var filters = {
        root: true,
        video_clip_id: true,
        language_id: this.targetLanguageId || 'DE'
      };
      if (this.searchQuery && this.searchQuery.match('"')) {
        filters['target_text'] = this.searchQuery.replace(/\"/g, '');
      } else if (this.searchQuery) {
        filters['target_text'] = "~".concat(this.searchQuery, "~");
      } else {
        (0, _lodash.each)(this.filterSettings.filter(function (item) {
          return (0, _utils.isPresent)(item.value);
        }), function (item) {
          filters[item.key] = item.filterValue || item.value;
        });
      }
      return filters;
    }
  }, {
    key: "filterSettings",
    get: function get() {
      var _this3 = this;
      var settings = [{
        key: 'level_id',
        userKey: 'vocabLevelId',
        label: 'Level',
        multiSelect: true,
        includeBlank: true,
        options: this.arrayToOptions(_constants.Constants.LEVELS.filter(function (item) {
          return item.abbreviation !== 'N';
        }), 'abbreviation'),
        filterType: 'select'
      }, {
        key: 'root_word_type_id',
        userKey: 'vocabWordTypeId',
        label: 'Word Type',
        multiSelect: true,
        includeBlank: true,
        options: this.arrayToOptions(_constants.Constants.VOCAB_WORD_TYPES, 'name'),
        filterType: 'select'
      }, {
        key: 'learned',
        userKey: 'vocabLearned',
        label: 'Learned',
        description: 'Words that you have marked as learned by clicking the "Star" icon.',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'reviewing',
        userKey: 'vocabReviewing',
        label: 'Reviewing',
        includeBlank: true,
        description: 'Words that you have added to a review deck.',
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'seen',
        userKey: 'vocabSeen',
        label: 'Word Seen',
        includeBlank: true,
        description: 'Words that you have seen on Seedlang. Words seen in a sentence context also count as "Seen".',
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'has_sentence',
        userKey: 'vocabHasSentence',
        label: 'Has Sentences',
        description: 'Words that have example sentences with a video recording.',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'has_highlighted_vocab_triad',
        userKey: 'vocabHasHighlightedVocabTriad',
        label: 'Has Highlighted Story',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'languages_string',
        userKey: 'vocabLanguagesWithWithout',
        label: 'Translations in Language',
        shortLabel: 'Translations',
        includeBlank: true,
        filterType: 'selectLanguage',
        showForLanguageId: ['DE'],
        options: [['with', 'Has Translations'], ['without', 'Has No Translations']],
        filterValue: "".concat(this.languagesWithWithout !== 'with' ? '!' : '').concat(this.user.languageId === 'EN2' ? 'EN' : this.user.languageId),
        customTag: this.languagesStringFormatted,
        showCustomTag: true
      }, {
        userKey: 'selectedWords',
        label: 'Words',
        value: this.selectedWordIds,
        customTag: "".concat(this.selectedWordIds.length, " Selected Word").concat(this.selectedWordIds.length === 1 ? '' : 's'),
        showCustomTag: true
      }];
      var filteredSettings = (0, _utils.isPresent)(this.selectedWordIds) ? settings.filter(function (item) {
        return item.userKey === 'selectedWords';
      }) : settings.filter(function (item) {
        return (!item.showForLanguageId || item.showForLanguageId.includes(_this3.targetLanguageId)) && item.userKey !== 'selectedWords';
      });
      return filteredSettings.map(function (item) {
        var hsh = {
          tagDisplay: item.showCustomTag ? item.customTag : (0, _utils.formatFilterTag)(item, _this3.filterCacheOrBackend(item.userKey)),
          value: _this3.filterCacheOrBackend(item.userKey)
        };
        return (0, _lodash.merge)(item, hsh);
      });
    }
  }, {
    key: "setShowFilterOptions",
    value: function setShowFilterOptions(showFilterOptions) {
      this.showFilterOptions = showFilterOptions;
    }
  }, {
    key: "updateMultipleSelectFilter",
    value: function updateMultipleSelectFilter(key, value) {
      if ((0, _utils.isBlank)(value) || !this.user[key] && !this.targetLanguage[key]) {
        this.filterCache[key] = [];
      } else if ((0, _utils.isBlank)(this.filterCache[key])) {
        var _value = this.filterCacheOrBackend(key);
        if ((0, _lodash.isArray)(_value)) {
          this.filterCache[key] = _value;
        } else {
          this.filterCache[key] = _value.split(',').filter(function (item) {
            return !(0, _utils.isBlank)(item);
          });
        }
      }
      if ((0, _utils.isPresent)(value)) {
        this.filterCache[key] = (0, _lodash.xor)(this.filterCache[key], [value]);
      }
    }
  }, {
    key: "tabs",
    get: function get() {
      var list;
      list = [{
        name: 'trainers',
        label: 'Vocab Trainers',
        "default": this.showTrainersTab
      }, {
        name: 'wordList',
        label: 'Dictionary',
        "default": !this.showTrainersTab
      }];
      if (this.layout.isNative) {
        list.push({
          name: 'progress',
          label: 'Progress',
          "default": false
        });
      }
      return list;
    }
  }, {
    key: "languagesEnable",
    get: function get() {
      return this.filterCacheOrBackend('vocabLanguagesEnable');
    }
  }, {
    key: "languageId",
    get: function get() {
      return this.filterCacheOrBackend('languageId');
    }
  }, {
    key: "hasSentence",
    get: function get() {
      return this.filterCacheOrBackend('vocabHasSentence');
    }
  }, {
    key: "hasHighlightedVocabTriad",
    get: function get() {
      return this.filterCacheOrBackend('hasHighlightedVocabTriad');
    }
  }, {
    key: "languagesWithWithout",
    get: function get() {
      return this.filterCacheOrBackend('vocabLanguagesWithWithout');
    }
  }, {
    key: "searchQuery",
    get: function get() {
      return this.filterCacheOrBackend('vocabSearchQuery');
    }
  }, {
    key: "sort",
    get: function get() {
      return this.filterCacheOrBackend('vocabSort') || 'frequency_ranking';
    }
  }, {
    key: "sortDirection",
    get: function get() {
      return this.filterCacheOrBackend('vocabSortDirection');
    }
  }, {
    key: "expandTranslation",
    get: function get() {
      return this.filterCacheOrBackend('vocabExpandTranslation');
    }
  }, {
    key: "wordTypesAreAllNoun",
    get: function get() {
      return (0, _utils.isBlank)(this.selectedWords.filter(function (item) {
        return item.wordType.abbreviation !== 'noun';
      }));
    }
  }, {
    key: "showNounButton",
    get: function get() {
      return this.wordTypesAreAllNoun && (0, _utils.isPresent)(this.selectedWordIds) || (0, _utils.isBlank)(this.selectedWordIds) && this.wordType && this.wordType.name === 'Noun';
    }
  }, {
    key: "wordType",
    get: function get() {
      var _this4 = this;
      if (this.wordTypeId && this.wordTypeId !== 'any' && this.wordTypeStore.hasIndexData) {
        return this.wordTypeStore.indexData.find(function (item) {
          return item.id === _this4.wordTypeId;
        });
      }
    }
  }, {
    key: "showNoResultsMessage",
    get: function get() {
      return !this.showSpinner && this.store.initialRequestReceived && !this.store.hasIndexData;
    }
  }, {
    key: "showColumnCheckbox",
    get: function get() {
      return this.user.isMember && this.store.initialRequestReceived && this.store.hasIndexData;
    }
  }, {
    key: "deckCreationDisabled",
    get: function get() {
      return !this.user.isMember;
    }
  }, {
    key: "deckButtonDisabled",
    get: function get() {
      var _Constants$REVIEW_CAR, _Constants$REVIEW_CAR2, _Constants$REVIEW_CAR3;
      if (this.cardTypeId === ((_Constants$REVIEW_CAR = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'gender';
      })) === null || _Constants$REVIEW_CAR === void 0 ? void 0 : _Constants$REVIEW_CAR.id)) {
        var _this$selectedWordsEx;
        return ((_this$selectedWordsEx = this.selectedWordsExcludedFromGenderTrainer) === null || _this$selectedWordsEx === void 0 ? void 0 : _this$selectedWordsEx.length) === this.selectedWords.length;
      }
      if (this.cardTypeId === ((_Constants$REVIEW_CAR2 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'plural';
      })) === null || _Constants$REVIEW_CAR2 === void 0 ? void 0 : _Constants$REVIEW_CAR2.id)) {
        var _this$selectedWordsEx2;
        return ((_this$selectedWordsEx2 = this.selectedWordsExcludedFromPluralTrainer) === null || _this$selectedWordsEx2 === void 0 ? void 0 : _this$selectedWordsEx2.length) === this.selectedWords.length;
      }
      if (this.cardTypeId === ((_Constants$REVIEW_CAR3 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'conjugation';
      })) === null || _Constants$REVIEW_CAR3 === void 0 ? void 0 : _Constants$REVIEW_CAR3.id)) {
        var _this$selectedWordsEx3;
        return ((_this$selectedWordsEx3 = this.selectedWordsExcludedFromConjugationTrainer) === null || _this$selectedWordsEx3 === void 0 ? void 0 : _this$selectedWordsEx3.length) === this.selectedWords.length;
      }
      return false;
    }
  }, {
    key: "selectedWordIds",
    get: function get() {
      return this.selectedWords.map(function (item) {
        return item.id;
      });
    }
  }, {
    key: "showSource",
    get: function get() {
      return !this.layout.isMobile;
    }
  }, {
    key: "showNounTrainerButtons",
    get: function get() {
      return (0, _utils.isBlank)(this.selectedWordIds) && this.wordType && this.wordType.name === 'Noun' || this.wordTypesAreAllNoun && (0, _utils.isPresent)(this.selectedWordIds);
    }
  }, {
    key: "showAddToReviewsButton",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWordIds);
    }
  }, {
    key: "page",
    get: function get() {
      if (this.overridePage) {
        return this.overridePage;
      } else if (this.pageFromParams) {
        return this.pageFromParams;
      }
      return 1;
    }
  }, {
    key: "showTrainersTab",
    get: function get() {
      return (0, _utils.isBlank)(this.vocabTab) || this.vocabTab === 'trainers';
    }
  }, {
    key: "pieChartTitle",
    get: function get() {
      var title;
      if (this.level && this.wordType) {
        title = "".concat(this.level.abbreviation, " ").concat(this.wordType.formattedName, "s");
      } else if (this.level) {
        title = "".concat(this.level.abbreviation, " Words");
      } else if (this.wordType) {
        title = "".concat(this.wordType.formattedName, "s");
      } else {
        title = 'Words';
      }
      return "".concat(title, " Progress");
    }
  }, {
    key: "pieChartData",
    get: function get() {
      var counts = this.wordStore.metaData;
      if (!counts) return [{
        y: 0
      }];
      var unseenCount = counts.totalWordTypeLevelCount - counts.learnedCount - counts.seenCount;
      var ary = [{
        y: counts.learnedCount
      }];
      if (counts.seenCount > 0) {
        ary.push({
          y: counts.seenCount
        });
      }
      if (unseenCount > 0) {
        ary.push({
          y: unseenCount
        });
      }
      return ary;
    }
  }, {
    key: "colors",
    get: function get() {
      var ary = [_constants.Theme.green, '#969696'];
      if (this.wordStore.metaData && this.wordStore.metaData.seenCount > 0) {
        ary.splice(1, 0, _constants.Theme.orange);
      }
      return ary;
    }
  }, {
    key: "reviewDecks",
    get: function get() {
      return this.reviewDeckStore.indexData;
    }
  }, {
    key: "filteredReviewDecks",
    get: function get() {
      var _this5 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this5.targetLanguageId && !item.archived;
      });
    }
  }, {
    key: "archivedReviewDecks",
    get: function get() {
      var _this6 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this6.targetLanguageId && item.archived;
      });
    }
  }, {
    key: "selectedWordsAreNouns",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWords) && this.selectedWords.filter(function (item) {
        var _item$wordType;
        return ((_item$wordType = item.wordType) === null || _item$wordType === void 0 ? void 0 : _item$wordType.id) === 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
      }).length === this.selectedWords.length;
    }
  }, {
    key: "selectedWordsAreVerbs",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWords) && this.selectedWords.filter(function (item) {
        var _item$wordType2;
        return ((_item$wordType2 = item.wordType) === null || _item$wordType2 === void 0 ? void 0 : _item$wordType2.id) === '4c4389c1-f805-4d1c-ba45-6721cf400aef';
      }).length === this.selectedWords.length;
    }
  }, {
    key: "cardTypeOptions",
    get: function get() {
      var _this$selectedWordsEx4;
      var options = [this.getCardTypeOption('vocab_word_translate'), this.getCardTypeOption('vocab_word_comprehend'), this.getCardTypeOption('vocab_word_options')];
      if (this.selectedWordsAreVerbs && !(((_this$selectedWordsEx4 = this.selectedWordsExcludedFromConjugationTrainer) === null || _this$selectedWordsEx4 === void 0 ? void 0 : _this$selectedWordsEx4.length) === this.selectedWords.length)) {
        options.push(this.getCardTypeOption('conjugation'));
      }
      if (this.selectedWordsAreNouns) {
        var _this$selectedWordsEx5, _this$selectedWordsEx6;
        if (!(((_this$selectedWordsEx5 = this.selectedWordsExcludedFromGenderTrainer) === null || _this$selectedWordsEx5 === void 0 ? void 0 : _this$selectedWordsEx5.length) === this.selectedWords.length)) {
          options.push(this.getCardTypeOption('gender'));
        }
        if (this.targetLanguageId === 'DE' && !(((_this$selectedWordsEx6 = this.selectedWordsExcludedFromPluralTrainer) === null || _this$selectedWordsEx6 === void 0 ? void 0 : _this$selectedWordsEx6.length) === this.selectedWords.length)) {
          options.push(this.getCardTypeOption('plural'));
        }
      }
      return options;
    }
  }, {
    key: "getCardTypeOption",
    value: function getCardTypeOption(slug) {
      var cardType = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === slug;
      });
      return cardType ? [cardType.id, cardType.name] : null;
    }
  }, {
    key: "selectedWordsExcludedFromGenderTrainer",
    get: function get() {
      var _this$selectedWords;
      var excludedWordsTargetText = (_this$selectedWords = this.selectedWords) === null || _this$selectedWords === void 0 ? void 0 : _this$selectedWords.filter(function (item) {
        return item.hideFromGenderTrainer;
      }).map(function (item) {
        return item.targetTextWithDefiniteArticle;
      });
      if (this.selectedWordsAreNouns && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "selectedWordsExcludedFromPluralTrainer",
    get: function get() {
      var _this$selectedWords2;
      var excludedWordsTargetText = (_this$selectedWords2 = this.selectedWords) === null || _this$selectedWords2 === void 0 ? void 0 : _this$selectedWords2.filter(function (item) {
        return item.hideFromPluralTrainer || item.noPlural;
      }).map(function (item) {
        return item.targetTextWithDefiniteArticle;
      });
      if (this.selectedWordsAreNouns && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "selectedWordsExcludedFromConjugationTrainer",
    get: function get() {
      var _this$selectedWords3;
      var excludedWordsTargetText = (_this$selectedWords3 = this.selectedWords) === null || _this$selectedWords3 === void 0 ? void 0 : _this$selectedWords3.filter(function (item) {
        return item.hideFromConjugationTrainer || !item.reviewed2;
      }).map(function (item) {
        return item.targetText;
      });
      if (this.selectedWordsAreVerbs && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposer && this.disposer();
    }
  }, {
    key: "keyIsMultiSelect",
    value: function keyIsMultiSelect(key) {
      var _this$filterSettings$;
      return (_this$filterSettings$ = this.filterSettings.find(function (item) {
        return item.userKey === key;
      })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
    }
  }, {
    key: "arrayToOptions",
    value: function arrayToOptions(object, field) {
      return object.map(function (item) {
        return [item.id, item[field]];
      });
    }
  }, {
    key: "filterCacheOrBackend",
    value: function filterCacheOrBackend(field) {
      if (field in this.filterCache) {
        return this.filterCache[field];
      } else if (targetLanguageFilters.includes(field)) {
        return this.targetLanguage[field];
      } else if ((0, _utils.isPresent)(this.user[field])) {
        return this.user[field];
      }
    }
  }, {
    key: "onSetNewReviewDeckName",
    value: function onSetNewReviewDeckName(newReviewDeckName) {
      this.newReviewDeckName = newReviewDeckName;
    }
  }, {
    key: "onCreateNewReviewDeck",
    value: function onCreateNewReviewDeck(callback) {
      if ((0, _utils.isBlank)(this.newReviewDeckName)) {
        return;
      }
      var data = {
        userId: this.user.id,
        deckType: 'review',
        name: this.newReviewDeckName,
        defaultReviewDeck: true,
        languageId: this.user.targetLanguageId
      };
      this.deckStore.create({
        data: data
      }, callback);
      this.newReviewDeckName = '';
    }
  }, {
    key: "onSetFilter",
    value: function onSetFilter(key, value, params) {
      var multiSelect = this.keyIsMultiSelect(key);
      if (key === 'selectedWords') {
        this.selectedWords = [];
      } else if (key === 'languageId') {
        this.wordStore.clearIndexData();
      } else if (multiSelect) {
        this.updateMultipleSelectFilter(key, value);
      } else {
        this.filterCache[key] = value;
      }
      this.overridePage = 1;
      var callback = !params || !params['skipGetWords'] ? this.getWords : _lodash.noop;
      if (key !== 'selectedWords' && key !== 'vocabSearchQuery') {
        var data = {};
        data[key] = multiSelect ? this.filterCache[key].filter(function (item) {
          return !(0, _utils.isBlank)(item);
        }).join(',') : value;
        if (key === 'vocabLanguagesWithWithout') {
          this.filterCache['vocabLanguagesEnable'] = (0, _utils.isPresent)(value);
          data['vocabLanguagesEnable'] = (0, _utils.isPresent)(value);
        }
        this.updateUserAndTargetLanguage(data, callback);
      }
      if (key === 'vocabHasSentence') {
        this.getLearnedByLevel();
      }
      this.updateCardType();
    }
  }, {
    key: "getLearnedByLevel",
    value: function getLearnedByLevel(languageId) {
      var params = {
        queryStrings: {
          words_have_sentences: this.user.vocabHasSentence,
          word_type_id: this.user.vocabWordTypeId,
          language_id: languageId
        }
      };
      this.dashboardStore.api(params, this.afterGetKnownByLevel, 'GET', 'learnedByLevel');
    }
  }, {
    key: "afterGetKnownByLevel",
    value: function afterGetKnownByLevel(resp) {
      this.learnedByLevel = resp;
    }
  }, {
    key: "setWord",
    value: function setWord(word) {
      var _this7 = this;
      _stores.WordStore.setShowData(word);
      var userTranslationData = {
        viewsCount: word.viewsCount,
        learned: word.learned,
        reviewing: word.reviewing,
        userTranslationId: word.userTranslationId,
        consecutiveGoodScores: word.consecutiveGoodScores
      };
      if (word.hasDictionaryConcept || word.hasRelatedWords) {
        _stores.WordStore.getShow({
          ids: {
            wordId: word.id
          }
        }, function (resp) {
          return _this7.afterSetWord(resp, userTranslationData);
        });
      }
    }
  }, {
    key: "afterSetWord",
    value: function afterSetWord(resp, userTranslationData) {
      var wordWithUserTranslationData = _objectSpread(_objectSpread({}, resp), userTranslationData);
      _stores.WordStore.setShowData(wordWithUserTranslationData);
    }
  }, {
    key: "setPageFromParams",
    value: function setPageFromParams(pageFromParams) {
      this.pageFromParams = pageFromParams;
    }
  }, {
    key: "setDefaultReviewDeckId",
    value: function setDefaultReviewDeckId(defaultReviewDeckId) {
      this.defaultReviewDeckId = defaultReviewDeckId;
    }
  }, {
    key: "updateUserAndTargetLanguage",
    value: function updateUserAndTargetLanguage(data, callback) {
      var _this8 = this;
      var targetLanguageUpdatedFilters = {};
      var userUpdatedFilters = {};
      (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
        if (targetLanguageFilters.includes(key)) {
          targetLanguageUpdatedFilters[key] = data[key];
          if (_this8.targetLanguageRequestIsPending) {
            _this8.queuedTargetLanguageData[key] = data[key];
          }
        } else {
          userUpdatedFilters[key] = data[key];
          if (_this8.user) {
            _this8.user.set(key, data[key]);
          }
          if (_this8.userRequestIsPending) {
            _this8.queuedUserData[key] = data[key];
          }
        }
      });
      if ((0, _lodash.keys)(targetLanguageUpdatedFilters).length > 0) {
        if (!this.targetLanguageRequestIsPending) {
          this.targetLanguageRequestIsPending = true;
          if (callback) {
            this.callback = callback;
          }
          this.targetLanguageStore.update({
            data: targetLanguageUpdatedFilters,
            ids: {
              languageId: this.targetLanguageId,
              userId: this.user.id
            }
          }, this.afterUpdateTargetLanguage);
        }
      }
      if ((0, _lodash.keys)(userUpdatedFilters).length > 0) {
        if (!this.userRequestIsPending) {
          this.userRequestIsPending = true;
          if (callback) {
            this.callback = callback;
          }
          this.authUserStore.update({
            data: data
          }, this.afterUpdateUser); // heritage: keep updating user vocab filters for heritage mobile apps
        }
      }
    }
  }, {
    key: "loadUser",
    value: function loadUser(callback, device) {
      this.authUserStore.getShow({
        queryStrings: {
          device_language_id: this.deviceLanguageId,
          device: device || this.layout.device
        }
      }, callback);
    }
  }, {
    key: "afterUpdateUser",
    value: function afterUpdateUser() {
      this.userRequestIsPending = false;
      if ((0, _utils.isPresent)(this.queuedUserData)) {
        this.updateUserAndTargetLanguage(this.queuedUserData);
        this.queuedUserData = {};
      } else {
        if (this.callback) {
          this.callback();
          this.loadUser();
          this.callback = null;
        }
      }
    }
  }, {
    key: "afterUpdateTargetLanguage",
    value: function afterUpdateTargetLanguage() {
      this.targetLanguageRequestIsPending = false;
      if ((0, _utils.isPresent)(this.queuedTargetLanguageData)) {
        this.updateUserAndTargetLanguage(this.queuedTargetLanguageData);
        this.queuedTargetLanguageData = {};
      } else {
        if (this.callback) {
          this.callback();
          this.loadUser();
          this.callback = null;
        }
      }
    }
  }, {
    key: "onSetTargetLanguageId",
    value: function onSetTargetLanguageId(targetLanguageId) {
      this.targetLanguageId = targetLanguageId;
    }
  }, {
    key: "updateLearnedByLevel",
    value: function updateLearnedByLevel(level, field, increment) {
      if (this.learnedByLevel) {
        var obj = this.learnedByLevel.find(function (item) {
          return item.label === level;
        });
        if (obj) {
          obj[field] += increment;
        }
      }
    }
  }, {
    key: "onToggleLearned",
    value: function onToggleLearned(word) {
      if (!word) {
        return;
      }
      word.set('learned', !word.learned);
      var increment = word.learned ? 1 : -1;
      this.updateLearnedByLevel(word.level.abbreviation, 'learned', increment);
      if (word.learned) {
        word.set('reviewing', false);
        this.wordStore.incrementMetaData('reviewsCount', -1);
      }
      this.wordStore.incrementMetaData('learnedCount', increment);
      this.createOrUpdateUserTranslation(word, {
        learned: word.learned
      }, this.afterCreateUserTranslation.bind(this, word));
    }
  }, {
    key: "createOrUpdateUserTranslation",
    value: function createOrUpdateUserTranslation(word, data, callback) {
      if (word.userTranslationId) {
        this.userTranslationStore.update({
          data: data,
          ids: {
            userTranslationId: word.userTranslationId
          }
        });
      } else {
        data.translationId = word.root ? word.id : word.rootWordId;
        this.userTranslationStore.create({
          data: data
        }, callback);
      }
    }
  }, {
    key: "afterCreateUserTranslation",
    value: function afterCreateUserTranslation(word, resp) {
      word.set('userTranslationId', resp.userTranslationId);
    }
  }, {
    key: "afterSubmitSourceInput",
    value: function afterSubmitSourceInput() {
      this.wordStore.reloadIndexFiltered({
        queryStrings: {
          vocab_list: true
        }
      });
    }
  }, {
    key: "clearSelectedWords",
    value: function clearSelectedWords() {
      this.selectedWords = [];
    }
  }, {
    key: "getWords",
    value: function getWords() {
      this.filteredItemsCount = null;
      this.wordStore.clearFilter();
      this.wordStore.setPage(this.page);
      this.wordStore.getIndex({
        queryStrings: {
          vocab_list: true
        },
        sort: this.sortWithDirection,
        filters: this.filters
      }, this.afterGetWords);
    }
  }, {
    key: "afterGetWords",
    value: function afterGetWords(resp) {
      this.wordStore.setIndexData(resp);
      if (resp.meta) {
        this.filteredItemsCount = resp.meta.totalCount;
      }
    }
  }, {
    key: "activeFilter",
    value: function activeFilter(value) {
      return (0, _utils.isPresent)(value) && value !== 'any';
    }
  }, {
    key: "onUpdateSearchQuery",
    value: function onUpdateSearchQuery(value, caretPosition) {
      if ((0, _utils.isBlank)(this.searchQuery) && (0, _utils.isPresent)(value) && this.vocabTab === 'trainers') {
        this.tabsPreviouslyTrainers = true;
        this.onSetVocabTab('wordList');
      } else if ((0, _utils.isPresent)(this.searchQuery) && (0, _utils.isBlank)(value) && this.tabsPreviouslyTrainers) {
        this.tabsPreviouslyTrainers = false;
        this.onSetVocabTab('trainers');
      }
      this.onSetFilter('vocabSearchQuery', value, {
        skipGetWords: true
      });
      this.caretPosition = caretPosition;
      clearInterval(this.interval);
      this.interval = setTimeout(this.getWords, 500);
    }
  }, {
    key: "insertText",
    value: function insertText(text, caretPosition) {
      var newValue;
      if (!caretPosition) {
        caretPosition = this.searchQuery ? this.searchQuery.length : 0;
      }
      if (this.disabled) {
        return;
      }
      if (this.searchQuery) {
        newValue = [this.searchQuery.slice(0, caretPosition), text, this.searchQuery.slice(caretPosition)].join('');
      } else {
        newValue = text;
      }
      this.onUpdateSearchQuery(newValue, caretPosition + 1);
    }
  }, {
    key: "onToggleAddWordToDeck",
    value: function onToggleAddWordToDeck(word, params) {
      if (this.user.isMember || (0, _utils.isPresent)(params) && params['alwaysAllow']) {
        this.selectedWords = (0, _lodash.xor)(this.selectedWords, [word]);
        this.updateCardType();
      }
    }
  }, {
    key: "updateCardType",
    value: function updateCardType() {
      var cardTypeOptionsIds = this.cardTypeOptions.map(function (option) {
        return option[0];
      });
      if (!cardTypeOptionsIds.includes(this.cardTypeId)) {
        this.cardTypeId = this.cardTypeOptions[0][0];
      }
    }
  }, {
    key: "onToggleExpandTranslation",
    value: function onToggleExpandTranslation() {
      this.onSetFilter('vocabExpandTranslation', !this.expandTranslation);
    }
  }, {
    key: "onToggleAddAllToDeck",
    value: function onToggleAddAllToDeck() {
      var _this9 = this;
      this.allToggleSelected = !this.allToggleSelected;
      if (this.allToggleSelected) {
        (0, _lodash.each)(this.words, function (word) {
          if (!_this9.selectedWords.find(function (item) {
            return item.id === word.id;
          })) {
            _this9.selectedWords.push(word);
          }
        });
      } else {
        (0, _lodash.each)(this.words, function (word) {
          _this9.selectedWords = _this9.selectedWords.filter(function (item) {
            return item.id !== word.id;
          });
        });
      }
      this.updateCardType();
    }
  }, {
    key: "onCreateReviews",
    value: function onCreateReviews(params) {
      var _this10 = this;
      if (!this.deckButtonDisabled) {
        this.allToggleSelected = false;
        this.cardStore.create({
          data: {
            interface_source: (0, _utils.isPresent)(params) && (0, _utils.isPresent)(params['interfaceSource']) ? params['interfaceSource'] : 'vocab-list',
            word_ids: this.selectedWordIds,
            deck_id: this.deckId || this.defaultReviewDeckId,
            cardTypeId: this.cardTypeId,
            languageId: (0, _utils.isPresent)(params) && params['languageId']
          }
        }, this.afterCreateReviews);
        setTimeout(function () {
          if (!_this10.createReviewsFinished) {
            _this10.createReviewsIsSlow = true;
            _this10.selectedWords = [];
            setTimeout(function () {
              return _this10.createReviewsIsSlow = false;
            }, 5000);
          }
        }, 1000);
      }
    }
  }, {
    key: "afterCreateReviews",
    value: function afterCreateReviews() {
      var _this11 = this;
      this.createReviewsFinished = true;
      this.deckIsBeingCreated = false;
      this.createReviewsIsSlow = false;
      this.selectedWords = [];
      setTimeout(function () {
        return _this11.createReviewsFinished = false;
      }, 5000);
    }
  }, {
    key: "onClickSort",
    value: function onClickSort(sort) {
      var sortDirection;
      if (this.sort === sort) {
        sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
      } else {
        sortDirection = 'asc';
      }
      this.onSetFilter('vocabSort', sort, {
        skipGetWords: true
      });
      this.onSetFilter('vocabSortDirection', sortDirection);
      this.getWords();
    }
  }, {
    key: "onSetVocabTab",
    value: function onSetVocabTab(vocabTab) {
      this.vocabTab = vocabTab;
      this.user.set('vocabTab', vocabTab);
      this.updateUserAndTargetLanguage({
        vocabTab: vocabTab
      }, _lodash.noop);
    }
  }, {
    key: "onSetCardTypeId",
    value: function onSetCardTypeId(cardTypeId) {
      this.cardTypeId = cardTypeId;
    }
  }, {
    key: "addWordVideoClip",
    value: function addWordVideoClip(wordId, videoClip) {
      this.wordVideoClips[wordId] = videoClip;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "filterCache", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedWords", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "caretPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "allToggleSelected", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userRequestIsPending", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageRequestIsPending", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "queuedUserData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "queuedTargetLanguageData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "vocabTab", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "tabsPreviouslyTrainers", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "deckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "cardTypeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "filteredItemsCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showFilterOptions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "overridePage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pageFromParams", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "learnedByLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "updatedDeviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "newReviewDeckName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "createReviewsIsSlow", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "createReviewsFinished", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "wordVideoClips", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "store", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "store"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "words", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "words"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetDeckId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetDeckId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearFilterCache", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilterCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "noFiltersSelectedMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortWithDirection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortWithDirection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSpinner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesStringFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesStringFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasActiveFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowFilterOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setShowFilterOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateMultipleSelectFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateMultipleSelectFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tabs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesEnable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesEnable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasHighlightedVocabTriad", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasHighlightedVocabTriad"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesWithWithout", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesWithWithout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortDirection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortDirection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expandTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "expandTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordTypesAreAllNoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordTypesAreAllNoun"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNounButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNounButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNoResultsMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNoResultsMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showColumnCheckbox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showColumnCheckbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckCreationDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckCreationDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckButtonDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckButtonDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNounTrainerButtons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNounTrainerButtons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAddToReviewsButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAddToReviewsButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "page", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "page"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTrainersTab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTrainersTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pieChartTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pieChartTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pieChartData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pieChartData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "colors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredReviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredReviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "archivedReviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "archivedReviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsAreNouns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsAreNouns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsAreVerbs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsAreVerbs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTypeOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromGenderTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromGenderTrainer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromPluralTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromPluralTrainer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromConjugationTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromConjugationTrainer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyIsMultiSelect", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "keyIsMultiSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "arrayToOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "arrayToOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterCacheOrBackend", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "filterCacheOrBackend"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetNewReviewDeckName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetNewReviewDeckName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreateNewReviewDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCreateNewReviewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getLearnedByLevel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getLearnedByLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetKnownByLevel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetKnownByLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterSetWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterSetWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPageFromParams", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setPageFromParams"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDefaultReviewDeckId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setDefaultReviewDeckId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateUserAndTargetLanguage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateUserAndTargetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterUpdateUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterUpdateUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterUpdateTargetLanguage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterUpdateTargetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetTargetLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetTargetLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLearnedByLevel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateLearnedByLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleLearned", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleLearned"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createOrUpdateUserTranslation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createOrUpdateUserTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateUserTranslation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateUserTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterSubmitSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterSubmitSourceInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onUpdateSearchQuery", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onUpdateSearchQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "insertText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleAddWordToDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleAddWordToDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCardType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleExpandTranslation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleExpandTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleAddAllToDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleAddAllToDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreateReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCreateReviews"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateReviews"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickSort", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onClickSort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetVocabTab", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetVocabTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetCardTypeId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetCardTypeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addWordVideoClip", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "addWordVideoClip"), _class.prototype), _class);
var _default = exports["default"] = new VocabUI();